export default __webpack_public_path__ + "assets/images/6f3ba7ac94c7fa77003e80933b6f0a2b.jpg";